@if (shouldRender()) {
	<div *transloco="let t; prefix: 'shAgGrid.common.labels'">
		@if (isMuted()) {
			<div class="sh-mute-status-container">
				<prism-icon icon="mic_off" class="sh-muted-icon" data-testid="muted-icon"></prism-icon>
				<span>{{ t('muted') }}</span>
			</div>
		} @else if (isUnmuted()) {
			<div class="sh-mute-status-container">
				<prism-icon icon="mic" class="sh-unmuted-icon" data-testid="unmuted-icon"></prism-icon>
				<span>{{ t('un-muted') }}</span>
			</div>
		} @else if (muteUnsupported()) {
			<span class="sh-mute-unsupported">{{ defaultDisplayValue }}</span>
		}
	</div>
}
